const signingOut = {
  'en-us': 'Signing out…',
  'pt-br': 'Saindo…',
  'es-es': 'Cerrando sesión…',
  'fr-ca': 'Déconnexion en cours…',
  'de-de': 'Abmeldung läuft…',
  'ru-ru': 'Выход из системы…',
  'pl-pl': 'Wylogowywanie…',
  'el-gr': 'Αποσύνδεση…',
  'zh-zh': '正在退出登录…',
  'it-it': 'Disconnessione in corso…',
  'hu-hu': 'Kijelentkezés…',
  'cs-cs': 'Odhlašování…',
  'da-dk': 'Logger ud…',
  'fi-fi': 'Kirjaudutaan ulos…',
  'no-no': 'Logger ut…',
  'sv-se': 'Loggar ut…'
};

export default Object.fromEntries(
  Object.entries(signingOut).map(([locale, text]) => [locale, { 'session.signingOut': text }])
);
